var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7222 14.7778V13.7222H10.5556V10.5556H13.7222V12.6667H15.8333V14.7778H14.7778V16.8889H12.6667V19H10.5556V15.8333H12.6667V14.7778H13.7222ZM19 19H14.7778V16.8889H16.8889V14.7778H19V19ZM0 0H8.44444V8.44444H0V0ZM2.11111 2.11111V6.33333H6.33333V2.11111H2.11111ZM10.5556 0H19V8.44444H10.5556V0ZM12.6667 2.11111V6.33333H16.8889V2.11111H12.6667ZM0 10.5556H8.44444V19H0V10.5556ZM2.11111 12.6667V16.8889H6.33333V12.6667H2.11111ZM15.8333 10.5556H19V12.6667H15.8333V10.5556ZM3.16667 3.16667H5.27778V5.27778H3.16667V3.16667ZM3.16667 13.7222H5.27778V15.8333H3.16667V13.7222ZM13.7222 3.16667H15.8333V5.27778H13.7222V3.16667Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.fb2e040cc78caf5887b25c782387a13a.svg";
export { ForwardRef as ReactComponent };